// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260407-3/static/css/" + chunkId + "." + {"2395":"53c8aa17","2425":"53c8aa17","2844":"53c8aa17","2979":"e9da9c29","2982":"07a465cd","4312":"e9da9c29","4767":"53c8aa17","7010":"e9da9c29","9214":"e9da9c29"}[chunkId] + ".chunk.css";
};